<app-navbar-style-two></app-navbar-style-two>
<div class="slider-area owl-carousel owl-theme">
  <div class="slider-item item-bg-agro">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="container">
                  <div class="slider-content">
                      <h1 i18n>Agriculture Management Software & Farm Business Solutions</h1>
                      <!-- <h2 i18n>Manage Seeds, Fertilizers, and Equipment with Advanced Inventory and Billing Abilities</h2> -->
                          <button i18n type="button" class="default-btn" (click)="appointment('Agrochemical Vertical')">Get Started Now</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<br>
<div class="container-md p-5 box-container">
    <p i18n style="color:white">Revolutionize your agricultural operations with Medeil’s Agriculture Management Software. Built for modern farms, agribusinesses, and distributors, Medeil empowers you to automate daily tasks, ensure compliance, and maximize productivity—all from a single, easy-to-use platform.</p>
</div>
<br>




<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">


  <div class="custom-modal">
     <button class="close-btn" (click)="closeModal()">X</button>
     <div class="modal-header">
         <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
     </div>
       <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div class="btn-group mt-3" *ngIf="!showElement">
             <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>

           </div>


         </form>
       </div>
 </div>
</ngx-smart-modal>
<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


  <div class="custom-modal"  >
     <button class="close-btn" (click)="closeModal()">X</button>
      <div class="modal-header-appointment">
          <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
      </div>
        <div class="modal-body">

           <div class="row">
              <div class="col-lg-12">
                 <mat-form-field >

                    <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                 </mat-form-field>

              </div>
              <div  align="center" *ngIf="showElement">
                 <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
               </div>
              <div class="col-lg-12" *ngIf="appointment_time">

                  <div class="button-container">
                    <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                 </div>
                 <div  align="center" *ngIf="showElementsave">
                  <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
                </div>
                  <div class="shedule-submit">
                    <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                  </div>
              </div>
           </div>

        </div>
  </div>
</ngx-smart-modal>
<div class="newslider" >

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp" alt="image" height="200" width="300" priority>
  </div>

</div>
<!-- <div class="section-title container gradient-text mb-2" >

    <h2>Features</h2>
</div> -->
<!-- ---------------------------- -->


<div id="services" class="services section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
            <div i18n class="gradient-text"><h2>Agro Store Management Software for Retail & Distribution </h2>for you</div>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
            <p i18n>
              Running an agriculture store or distribution business is no small task. From managing seasonal inventory like seeds, fertilizers, and equipment to handling bulk orders and customer relationships, the challenges can quickly add up. That’s where Medeil’s Agro Store Software comes in – a smart, all-in-one solution designed to simplify your operations and help your business grow.
            </p>
          </div>
        </div>
      </div>
    </div>


<!-- start of key feature-->
<section class="about section-padding" id="features">
    <div class="section-title gradient-text ">
        <h2 i18n style="text-align: center;">Key Features of Medeil Agriculture Software</h2>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-10 col-12 ms-lg-auto mb-2 mb-lg-0">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button i18n class="nav-link active" id="nav-intro-tab" data-bs-toggle="tab" data-bs-target="#nav-intro" type="button" role="tab" aria-controls="nav-intro" aria-selected="true">Real-Time Farm Inventory Management</button>
                        <button i18n class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Sales and Supply Chain Management</button>
                        <button i18n class="nav-link" id="nav-faq-tab" data-bs-toggle="tab" data-bs-target="#nav-faq" type="button" role="tab" aria-controls="nav-faq" aria-selected="false">Compliance and Documentation</button>
                        <button i18n class="nav-link" id="nav-faq-data" data-bs-toggle="tab" data-bs-target="#nav-data" type="button" role="tab" aria-controls="nav-data" aria-selected="false">Crop and Resource Planning</button>
                    </div>
                </nav>
            </div>
            <div class="col-12">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-intro" role="tabpanel" aria-labelledby="nav-intro-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/opticalchainstoresoftware - medeilcloud hq.png" class="img-fluid" alt="optical chain store software - medeilcloud hq" height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Real-Time Farm Inventory Management</h3>
                                  <p i18n>Track seeds, fertilizers, equipment, and harvests with automated stock updates and low-inventory alerts.</p>
                                    <!-- <p i18n>Administrators should be able to monitor and manage all pharmacy locations' activities from a single dashboard thanks to the software's centralized management features.</p> -->
                                    <!-- <p i18n>Managing user access, pricing, promotions, and inventory are all included in this.</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <div class="row">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Sales and Supply Chain Management</h3>
                              <!-- <p i18n>In order to allow each pharmacy to function independently and to enable centralized management and communication between stores, the software should handle several pharmacy locations. </p> -->
                              <p i18n> Streamline order processing, manage multiple sales channels, and monitor supply chain performance with detailed analytics.</p>
                            </div>

                            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloud hq.png" class="img-fluid" alt="medical device software for chainstores medeilcloud hq"  height="400" width="500" priority>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade mb-4" id="nav-faq" role="tabpanel" aria-labelledby="nav-faq-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/multi store software = medeilcloud hq.png" class="img-fluid" alt="multi store software medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Compliance and Documentation</h3>

                              <!-- <p i18n>The software must give top priority to safeguarding patient information and adhering to HIPAA (Health Insurance Portability and Accountability Act) and other healthcare standards, such as WHO-DDD, WHO-ATC Coding, and WHO-ICD Standards.</p> -->
                              <p i18n>Maintain up-to-date records for regulatory audits, certifications, and traceability of crops and products.</p>


                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade mb-4" id="nav-data" role="tabpanel" aria-labelledby="nav-faq-data">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/chainsoftware-medeilcloud hq.png" class="img-fluid" alt="chain software-medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Crop and Resource Planning</h3>

                             <p i18n>
                              Plan planting, irrigation, and harvesting schedules for optimal yield and resource utilization.</p>
                                <!-- <p i18n>This features support for upcoming expansions, modifiable processes, and adjustable settings.</p> -->
                            </div>
                         </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div id="faq"></div>
</section>
<!-- end of key feature -->


<!-- start of why choose -->
<section class="hosbay-section">
    <div class="container">
        <div class="cta-section">
            <h2 i18n>Why Choose Medeil for Farm and Agribusiness Management?</h2>
            <p i18n>Medeil stands out for its robust security, intuitive interface, and flexible modules that adapt to any agricultural business. Whether you manage a small family farm or a large agribusiness, Medeil streamlines your workflow, reduces manual errors, and ensures you meet all industry regulations. Our dedicated support team and regular software updates keep your operations running smoothly and securely.</p>
            <button i18n type="button" class="default-btn" (click)="appointment('Contact Us')" style="height:60px; width:200px">Contact Us</button>
        </div>
    </div>
</section>

<!-- end of why choose -->




    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="service-item first-service">
            <div class="icon"></div>
            <h6 i18n>Save Time and Reduce Errors</h6>
           <p i18n style="line-height: 1.3;">
            Automate repetitive tasks like inventory tracking, billing, and order management, so you can focus on growing your business.
           </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item second-service">
            <div class="icon"></div>
            <h6 i18n>Improve Customer Experience</h6>
          <p i18n style="line-height: 1.3;">
            Provide faster, more personalized service with features like CRM and bulk order management.
          </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item third-service">
            <div class="icon"></div>
            <h6 i18n>Optimize Inventory</h6>
          <p i18n style="line-height: 1.5;">
            Avoid overstocking or running out of essential products with real-time inventory tracking and alerts.
          </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item fourth-service">
            <div class="icon"></div>
            <h6 i18n>Boost Profitability</h6>
            <p i18n style="line-height: 1.9;">
              Use sales insights to identify trends, plan promotions, and increase revenue.
            </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ---------------------------- -->

<!-- about  -->
<div id="about" class="about-us section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 align-self-center">
          <div class="section-heading">
            <h4 i18n>About who we are?</h4>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
         <p i18n>
            At Vanuston, our area of expertise is offering vital agrochemical goods and services to help farmers, ranchers, and crop producers maximize crop yields and maximize farm production. With an emphasis on quality, sustainability, and client happiness, we provide a wide range of agrochemical solutions that are specifically designed to satisfy the various demands of our customers.
         </p>
          </div>
          <div class="row">
              <div class="col-lg-6">
                  <div class="box-item" routerLink="/medeil">
                    <h5 i18n><a >Standalone Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="box-item" routerLink="/medeilcloudpos">
                    <h5 i18n><a >SaaS Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="box-item" routerLink="/medeilcloudhq">
                    <h5 i18n><a >Chain Store Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="box-item" routerLink="/allotmed">
                    <h5 i18n><a >Distribution Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
                <div class="col-lg-12 text-center">
                  <div class="box-item" routerLink="/hosbay-healthcare">
                    <h5 i18n><a >Hospital Inventory  Version</a></h5>
                    <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                  </div>
                </div>
            <div class="col-lg-12">
           <p i18n>
            Vanuston is a reliable resource and partner for farmers and agricultural enterprises, not just a supplier of agrochemicals. With a thorough awareness of the difficulties and possibilities facing contemporary agriculture, we are dedicated to assisting our clients in becoming successful by giving them the tools, know-how, and assistance they require to prosper in the cutthroat agribusiness environment of today.
           </p>
              <div>
                <!-- <button class="gradient-button"> Start Free Trial</button> -->
               </div>
              <!-- <span>*No Credit Card Required</span> -->
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="right-image">
            <!-- <img src="assets/images/about-right-dec.png" alt=""> -->
            <img src="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloudpos.gif" alt="medical pos billing- medeilcloud pos" loading="lazy">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ---- -->
<!-- ---------------------------- -->
<section class="agro-benefits-section">
  <div class="agro-container">
      <h3 i18n class="agro-title">Who Can Benefit from Medeil’s Agro Store Software?</h3>
      <p i18n class="agro-description">
          Our software helps agriculture businesses streamline operations, manage inventory, and enhance efficiency.
      </p>

      <div class="agro-cards">
          <div class="agro-card">
              <div class="agro-icon"><i class="fas fa-seedling"></i></div>
              <h3 i18n>Independent Agro Stores</h3>
              <p i18n>Upgrade your agriculture store with modern tools for inventory and sales tracking.</p>
          </div>

          <div class="agro-card">
              <div class="agro-icon"><i class="fas fa-tractor"></i></div>
              <h3 i18n>Agro Distributors</h3>
              <p i18n>Manage bulk orders, multiple clients, and seamless deliveries with ease.</p>
          </div>

          <div class="agro-card">
              <div class="agro-icon"><i class="fas fa-store"></i></div>
              <h3 i18n>Farm Supply Stores</h3>
              <p i18n>Track inventory for seeds, fertilizers, and farming equipment effortlessly.</p>
          </div>


          <div class="agro-card">
              <div class="agro-icon"><i class="fas fa-store"></i></div>
              <h2 i18n>Farmers who wants to sale</h2>
              <p i18n>Farmers seeking to modernize inventory and sales management</p>
          </div>

          <div class="agro-card">
              <div class="agro-icon"><i class="fas fa-store"></i></div>
              <h2 i18n>Agro Businesses</h2>
              <p i18n>Agribusinesses and cooperatives needing centralized control and compliance</p>
          </div>

          <div class="agro-card">
              <div class="agro-icon"><i class="fas fa-store"></i></div>
              <h2 i18n>Agri consultants</h2>
              <p i18n>Agricultural consultants and service providers aiming to deliver reliable, data-driven solutions</p>
          </div>
      </div>
  </div>
</section>


<br>
<section class="box-container">
    <div class="container">
        <div class="cta-section">
            <h2 i18n>Secure, Scalable, and Compliant Agriculture ERP</h2>
            <p i18n>Medeil is more than just management software—it’s a complete ERP solution for agriculture businesses. Enjoy enterprise-grade security, effortless scalability as your business grows, and an intuitive interface that requires minimal training. Stay ahead of the competition and deliver outstanding results with Medeil.</p>
        </div>
    </div>
</section>
<br>




<div class="container mt-4">
    <div class="section-title gradient-text mt-2 mb-2" >

        <h2 i18n>Frequently Asked Questions</h2>
    </div>
    <div class="row pt-4">
        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: How does your software support precision agriculture and variable rate application techniques?</h4>
                <p i18n><strong>A:</strong> This question pertains to the software's functionalities for implementing precision agriculture practices, such as variable rate seeding, fertilization, and irrigation. Responses may include precision mapping tools, prescription generation algorithms, and equipment integration capabilities that enable precise input application based on spatial and temporal variability in the field.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: How does the agricultural value chain's stakeholders' cooperation and data exchange become supported by your farm software?</h4>
                <p i18n><strong>A:</strong> This inquiry focuses on how well the software can help farmers, agronomists, suppliers, distributors, and other stakeholders collaborate, communicate, and share data. In order to facilitate smooth communication and cooperation throughout the agricultural ecosystem, possible solutions include cloud-based collaboration platforms, data exchange standards, and API connections.   </p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Which are the sub vertical in agriculture software space do you support?</h4>
                <p i18n><strong>A:</strong> We support manufacturer, distribution, retailing for agro finished products, pesticide & insecticide stores, fertilizer shop, dairy industries, etc.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Is it possible for your program to offer documents related to compliance and traceability for food safety and regulatory requirements?</h4>
                <p i18n><strong>A:</strong>This inquiry concerns the software's ability to trace agricultural products' origin, manufacturing method, and distribution in order to guarantee food safety and legal compliance. Features that assist farmers in adhering to industry norms and regulatory obligations, such as batch traceability, audit trails, and compliance reporting capabilities, may be included in the response. </p>
            </div>
        </div>
    </div>


</div>
<div class="row mb-3 mt-3" style="width: 100%;">
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Crowd Review</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.3/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Google</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.8/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Capterra</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.4/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Software Suggest</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.7/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>G2 Crowd</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.1/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Trust Radius</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.6/5.0</p>
        </div>
  </div>
</div>


<br>
<div class="container-md p-5 box-container">
  <h3 i18n style="color: white;">Call to Action</h3>
  <p i18n style="color:white">Ready to transform your farm or agribusiness? Request a free demo of Medeil Agriculture Management Software and discover how our solution can simplify your operations and boost your productivity.</p>
  <a i18n (click)="appointment('Agro Demo')" class="cta-button">🚀 Request a Free Demo</a>
  </div>
<br>
<app-footer-style-two></app-footer-style-two>
